/**
 * ContainerWithoutPadding.jsx
 *
 * Layout wrapper for internal pages that need full-width content.
 * Wraps the child route in PageShell with padding disabled:
 * - Gradient background matching Home page
 * - No horizontal padding (full-width content)
 * - Header disabled (pages manage their own titles via TopicTitle)
 *
 * Used by routes: dental-education, oral-supplier, virtual-consultation, dental-ai
 */
import {Outlet} from 'react-router';
import PageShell from './PageShell';

export default function ContainerWithoutPadding() {
  return (
    <PageShell title="" showHeader={false} padContent={false}>
      <div style={{padding: '0 18px 132px'}}>
        <Outlet />
      </div>
    </PageShell>
  );
}
